export default "__VITE_ASSET__Bj6Yz_MX__"